export default "__VITE_ASSET__42a79c19__"